<script lang="ts">
    import { formatError } from "@repo/utils";

    const { e }: { e: unknown } = $props();
</script>

<pre class="text-error-foreground">{formatError(e)}</pre>
